<script lang="ts" setup>
const {
  avatar = undefined,
  color,
} = defineProps<{
  avatar?: string
  title: string
  subtitle: string
  description: string
  color: 'primary' | 'secondary'
}>()

const bgColor = computed(() => {
  if (color === 'primary') return 'linear-gradient(45deg, rgb(var(--v-theme-primary-900)) 0%, rgb(var(--v-theme-primary-600)) 100%)'
  if (color === 'secondary') return 'linear-gradient(45deg, rgb(var(--v-theme-gray-900)) 0%, rgb(var(--v-theme-gray-600)) 100%)'
  return 'rgb(var(--v-theme-gray-900))'
})

const borderColor = computed(() => {
  if (color === 'primary') return 'rgba(var(--v-theme-primary-400), .5)'
  if (color === 'secondary') return 'rgba(var(--v-theme-gray-400), .5)'
  return 'rgb(var(--v-theme-gray-400))'
})
</script>

<template>
  <v-card
    rounded="xll"
    width="100%"
    max-width="400px"
    class="pa-6 text-white d-flex flex-column ga-4 select-none"
    :style="{
      background: bgColor,
      border: `1px solid ${borderColor}`,
      boxShadow: '8px 10px 16px 0 rgba(0, 0, 0, 0.05)',
    }"
  >
    <div class="d-flex flex-row align-center ga-5">
      <v-avatar
        color="white"
        :size="48"
        :image="avatar"
      />
      <div class="d-flex flex-column">
        <div class="text-body-1 font-weight-medium">
          {{ title }}
        </div>
        <div class="text-body-2 font-weight-regular">
          {{ subtitle }}
        </div>
      </div>
    </div>
    <div class="flex-grow-1">
      {{ description }}
    </div>
  </v-card>
</template>
